import React, { FC, useCallback, useLayoutEffect, useMemo, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { GrowlContainer, Icon, Overlay } from '@wmgtech/legato'

import { Search } from 'modulesCommon/Header/containers'
import { Logo } from 'components'
import { cn } from 'shared/utils'
import { HeaderMenu } from 'modulesCommon/Header/components'
import { HeroImage } from 'modulesCommon/Header/components/HeroImage'
import { useScroll } from 'shared/hooks'
import { NotificationDropDown, ProductMatchNotificationsModal } from 'modulesCommon/Notifications/containers'


import styles from './global-hub-header.module.scss'

import { GHHeaderProps } from './GHHeader.props'

export const GHHeader: FC<GHHeaderProps> = ({ isLoading, activeArtist }) => {
  const container = useRef<HTMLHeadingElement>()
  const { pathname } = useLocation()
  const [refProxy] = useScroll((ref, offset) => {
    ref.style.setProperty('--sbx-header-height', 100 - offset + 'px')
    ref.style.setProperty('--sbx-header-transition', -offset + 'px')
    ref.style.setProperty('--sbx-header-opacity', (1 - offset / 60).toString())
  }, 60)

  const proxyContainer = useCallback(
    (el: HTMLHeadingElement) => {
      container.current = el
      refProxy(el)
    },
    [refProxy]
  )

  const isProjectDetailPage = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, __, third, forth] = pathname.split('/')
    return third === 'project' && /^\d+$/.test(forth)
  }, [pathname])

  useLayoutEffect(() => {
    setTimeout(() => {
      if (container.current) {
        if (isProjectDetailPage) {
          container.current.classList.add(styles.mount)
        } else {
          container.current.classList.remove(styles.mount)
        }
      }
    }, 100)
  }, [isProjectDetailPage])

  return (
    <header ref={proxyContainer} className={cn(styles.header, { [styles.isAnimate]: isProjectDetailPage })}>
      <div className={styles.wrapper}>
        <HeroImage activeArtist={activeArtist} />
        <div className={styles.inner}>
          <div className={cn(styles.logo)}>
            <Link to="/globalhub">
              <Logo isLoading={isLoading} />
            </Link>
            <Overlay
              trigger={
                <div>
                  <span className={styles.logoText}>Global Hub</span>
                  <Icon name={'circle-chevron-down'} className={styles.logoDropdownIcon} />
                </div>
              }
              placement={'bottom-start'}
              showFang={false}
              hooks={{
                click: { enabled: true }
              }}
            >
              <div className={'items-list'}>
                <Link to={'/feed'} className={'items-list__item'}>
                  <span> Go to Storybox</span>
                </Link>
              </div>
            </Overlay>
          </div>

          <Search />

          <div className={styles.right}>
            <NotificationDropDown />
            <HeaderMenu />
          </div>
        </div>
      </div>
      <GrowlContainer
        closeOnClick={false}
        closeButton={false}
        hideProgressBar={true}
        newestOnTop={true}
        rtl={false}
        autoClose={5000}
        className={'header-growl-container'}
      />
      <ProductMatchNotificationsModal />
    </header>
  )
}
